// extracted by mini-css-extract-plugin
export default {"container":"Description-module__container--kj4Af","text-wrapper":"Description-module__text-wrapper--ArKdO","text":"Description-module__text--XWFIB"};